import { render, staticRenderFns } from "./mobileAppStoreButton.vue?vue&type=template&id=4f7e5044&scoped=true&"
import script from "./mobileAppStoreButton.vue?vue&type=script&lang=js&"
export * from "./mobileAppStoreButton.vue?vue&type=script&lang=js&"
import style0 from "./mobileAppStoreButton.vue?vue&type=style&index=0&id=4f7e5044&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f7e5044",
  null
  
)

export default component.exports